const { default: styled } = require('styled-components');
import { connect } from 'react-redux';
import { ContentScreen } from '../styles/ContentScreen';
import { Button } from '../components/Button';
import { stripeEnv } from '../util/constants';

const Wrapper = styled.div`
   display: flex;
   flex-wrap: wrap;
   position: fixed;
   z-index: 9999;
   flex-direction: column;
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   justify-content: center;
   align-items: center;
   padding: 40px;
   background-color: var(--background-color);
   opacity: 1;
   transition: opacity 0.5s ease-in-out;
`;

const mapStateToProps = ({
   appData: {
      permissions: { errorCode },
   },
}) => ({
   permissionsError: errorCode,
});

const PermissionsErrorOverlay = connect(mapStateToProps)(
   ({ permissionsError }) => {
      if (permissionsError === 'NetworkError') {
         return (
            <Wrapper>
               <ContentScreen>
                  <h1>A network error occurred.</h1>
                  <p>
                     Please check your internect connection and try again in a
                     few minutes.
                  </p>
               </ContentScreen>
            </Wrapper>
         );
      }
      if (permissionsError === 'UnexpectedError') {
         return (
            <Wrapper>
               <ContentScreen>
                  <h1>An error occurred.</h1>
                  <p>Please try again in a few minutes.</p>
               </ContentScreen>
            </Wrapper>
         );
      }
      if (permissionsError === 'SubscriptionExpiredError') {
         return (
            <Wrapper>
               <ContentScreen>
                  <h1>Subscribe</h1>
                  <p style={{ marginBottom: '2em' }}>
                     Your subscription to Ear Instructor has expired.
                  </p>
                  <p>
                     <Button
                        as="a"
                        href={stripeEnv.billingConsoleLink}
                        target="_blank"
                        className="button-cta"
                     >
                        Manage Your Subscription
                     </Button>
                  </p>
               </ContentScreen>
            </Wrapper>
         );
      }
   }
);

export { PermissionsErrorOverlay };
